import React from "react";
import { Paginator } from "primereact/paginator";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { Ripple } from "primereact/ripple";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

function CustomPagination({
  currentPage,
  rowsPerPage,
  totalRecords,
  onPageChange,
  totalPages,
  darkBg = false,
  rowsPerPageOptions
}) {
  const handlePageChange = (event) => {
    onPageChange(event.page + 1, event.rows);
  };
  const { t, i18n } = useTranslation();
  const template = {
    layout:
      "PrevPageLink PageLinks NextPageLink RowsPerPageDropdown CurrentPageReport",
    PrevPageLink: (options) => {
      return (
        <button
          type="button"
          className={classNames(options.className, "border-round", darkBg && "!text-white hover:!bg-white/10")}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="flex justify-center p-3 gap-2 items-center">
            {i18n.language === "en" ? <FaArrowLeftLong /> : <FaArrowRightLong />}
            {t("Previous")}
          </span>
          <Ripple />
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button
          type="button"
          className={classNames(options.className, "border-round", darkBg && "!text-white hover:!bg-white/10")}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="flex justify-center p-3 gap-2 items-center">
            {t("Next")}
            {i18n.language === "en" ? <FaArrowRightLong /> : <FaArrowLeftLong />}
          </span>
          <Ripple />
        </button>
      );
    },
    PageLinks: (options) => {
      if (
        (options.view.startPage === options.page &&
          options.view.startPage !== 0) ||
        (options.view.endPage === options.page &&
          options.page + 1 !== options.totalPages)
      ) {
        const className = classNames(options.className, { "p-disabled": true });
        return (
          <span className={className} style={{ userSelect: "none" }}>
            ...
          </span>
        );
      }
      return (
        <button
          type="button"
          className={classNames(options.className, darkBg && "!text-white hover:!bg-white/10")}
          onClick={options.onClick}
        >
          {options.page + 1}
          <Ripple />
        </button>
      );
    },
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = rowsPerPageOptions?.length>0?rowsPerPageOptions:[
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 30, value: 30 },
      ];
      return (
        <Dropdown
          value={options.value}
          options={dropdownOptions}
          onChange={options.onChange}
          className={`!h-[32px] !w-20 ${darkBg ? "!bg-white" : ""}`}
          pt={{
            root: { className: "w-full md:w-full p-primary-input" },
            input: {
              className: "w-full p-primary-input !p-0 !px-1 flex items-center",
            },
            filterInput: { className: "mr-0" },
            filterIcon: {
              className: "rtl:right-auto rtl:left-4 dark:text-white",
            },
          }}
        />
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span className={`mx-3 ${darkBg ? "text-white" : ""}`}>{`${t("TotalRecords")} ${totalRecords}`}</span>
      );
    },
  };

  return (
    <div className="!mt-4">
      <Paginator
        first={(currentPage - 1) * rowsPerPage}
        rows={rowsPerPage}
        totalRecords={totalRecords ?? totalPages * rowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions?.length>0?rowsPerPageOptions:[5, 10, 20, 30]}
        onPageChange={handlePageChange}
        template={template}
        className="!bg-transparent"
        pt={{
          pages: { className: "flex gap-4 items-center" },
        }}
      />
    </div>
  );
}

export default CustomPagination;
